var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueTeamplay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#05bdcf",
    d: "M6.25 5.25h1.5V7.5H10V9H7.75v2.25h-1.5V9H4V7.5h2.25zm-6-2.398v7.49a4.5 4.5 0 002.004 3.744L7 17.25l4.746-3.164a4.5 4.5 0 002.004-3.744v-7.49a.75.75 0 00-.587-.732L7 .75.837 2.12a.75.75 0 00-.587.732z"
  })));
}
export default __webpack_public_path__ + "static/svg/blue-teamplay.svg";
export { SvgBlueTeamplay as ReactComponent };